import { jsx as c } from "react/jsx-runtime";
import { useTranslation as g, useLocalizedCountries as y, ContactSlugEnum as o, FormInput as d, getContactFieldTitle as b, FormInputPhone as E, getContactSlugName as m, FormSelect as q } from "@systemeio/ui";
import { useVisitorInfoStore as N } from "../store/index.mjs";
import { useLocaleContext as T } from "../providers/use-locale-provider.mjs";
const H = ({
  value: e,
  error: t,
  field: u,
  onChange: n,
  contactFields: l
}) => {
  var r;
  const { locale: h } = T(), { visitorInfo: a } = N(), { t: s } = g(), { countryData: p } = y(), C = (r = l[o.Country]) != null && r.value ? l[o.Country].value : (a == null ? void 0 : a.country) ?? void 0;
  switch (u.slug) {
    case o.Country:
      return /* @__PURE__ */ c(
        q,
        {
          label: m(u.slug, s),
          className: "focus:!border-THEME-primary",
          required: u.required,
          data: p,
          value: e,
          withoutCloseIcon: !0,
          onChange: (i) => n(i),
          error: t == null ? void 0 : t.join(", ")
        }
      );
    case o.PhoneNumber:
      return /* @__PURE__ */ c(
        E,
        {
          label: m(u.slug, s),
          inputClassName: "focus:!border-THEME-primary",
          required: u.required,
          value: e,
          onChange: n,
          initialCountry: C,
          error: t == null ? void 0 : t.join(", ")
        }
      );
    default:
      return /* @__PURE__ */ c(
        d,
        {
          label: b(u, s),
          inputClassName: "focus:!border-THEME-primary",
          required: u.required,
          value: e,
          onChange: ({ target: { value: i } }) => n(i),
          error: t == null ? void 0 : t.join(", ")
        },
        u.slug
      );
  }
};
export {
  H as default
};
